import { Component, Input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { AsyncPipe } from '@angular/common'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { AuthMe } from '@/app/core/models/auth'
import { getAuthMe } from '@/app/store/auth/auth.selector'
import { logout } from '@/app/store/auth/auth.actions'

@Component({
  selector: 'app-profile-dropdown',
  standalone: true,
  imports: [NgbDropdownModule, NgbTooltipModule, RouterLink, AsyncPipe],
  templateUrl: './profile-dropdown.component.html',
  styles: `
    .nav-avatar-btn {
      display: flex;
      align-items: center;
      text-decoration: none;

      &::after {
        display: none;
      }
    }

    .nav-avatar-circle {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: linear-gradient(135deg, #1D4ED8 0%, #0891B2 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 600;
      color: #fff;
      border: 2px solid rgba(255, 255, 255, 0.25);
      font-family: 'Plus Jakarta Sans', sans-serif;
      cursor: pointer;
      flex-shrink: 0;
    }
  `,
})
export class ProfileDropdownComponent {
  @Input() showThemeToggler: boolean = false
  @Input() className: string = ''

  me$!: Observable<AuthMe | null>

  constructor(private store: Store) {
    this.me$ = this.store.select(getAuthMe)
  }

  getInitials(me: AuthMe | null): string {
    if (!me) return 'U'
    const name = `${me.name || ''} ${me.last_name || ''}`.trim()
    return name
      .split(' ')
      .slice(0, 2)
      .map(n => n[0]?.toUpperCase() || '')
      .join('')
  }

  onLogout(evt?: Event) {
    if (evt) evt.preventDefault()
    this.store.dispatch(logout())
  }
}